
export function getAPIURL(): string {
  return window.location.protocol + "//" + window.location.host.replace(/^ui/, "api");
}
export function getFrontendURL(): string {
  return window.location.protocol + "//" + window.location.host.replace(/^ui/, "app");
}

export function calcImageURL(url: string | null): string {
  if (!url) {
      return "";
  }

  if (url.startsWith("http") || url.startsWith("data:")) {
    return url;
  } else {
    return getFrontendURL() + "/" + url;
  }
}